import { render, staticRenderFns } from "./PopupInput.vue?vue&type=template&id=684b956c&scoped=true"
import script from "./PopupInput.vue?vue&type=script&lang=js"
export * from "./PopupInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684b956c",
  null
  
)

export default component.exports